export enum MediaCommsContactTab {
	Messages = "Messages",
	Metrics = "Metrics",
}

export enum MediaCommsContentKey {
	General = "General",
	Settings = "Settings",
}
